import { render } from "./FundList.vue?vue&type=template&id=0ef318e0"
import script from "./FundList.vue?vue&type=script&lang=js"
export * from "./FundList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__